import React from "react";
import './HomeworkTable.sass';
import _ from 'lodash';
import moment from "moment/moment";
import {getNameByValue, solveTypes, taskTypes, themes} from "../../../common/themes";
import {useNavigate, useParams} from "react-router";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

export default function HomeworkTable({data}) {
    const {id: groupId} = useParams();

    const {data: group} = useSelector(state => state.groups.selected);

    const navigate = useNavigate();

    if (_.isEmpty(data)) {
        return (
            <div className="HomeworkTable-wrapper">
                <div className="HomeworkTable-content">
                    <div className="HomeworkTable-content-empty">
                        Домашнее задание ещё не задано
                    </div>
                </div>
            </div>)
    }

    const students = {}
    data.forEach(d => {
        students[d.student.id] = d.student
    });
    const other = {}
    group.students.forEach(student => {
        const filter = data.filter(d => student.id === d.student.id);
        if (filter.length === 0) {
            other[student.id] = student
        }
    })


    const homeworks = {};

    data.forEach(d => {
        const {createDate} = d;

        if (_.isEmpty(homeworks[createDate])) {
            homeworks[createDate] = [d]
        } else {
            homeworks[createDate] = [...homeworks[createDate], d]
        }
    })

    for (let key in homeworks) {
        homeworks[key].sort((a, b) => a.student.lastName > b.student.lastName && a.student.firstName > b.student.firstName)
    }

    const renderName = (student) => {
        const {id, lastName, firstName} = student;
        return (
            <div key={`Homework-student-${id}`}
                 title="Изменить домашнее задание ученику"
                 onClick={() => navigate(`/home/group/${groupId}/homework/${student.id}`)}
                 className="HomeworkTable-name">
                <div className="HomeworkTable-name-text">
                    {`${lastName} ${firstName}`}
                </div>
            </div>
        )
    }

    const renderSteps = (hw) => {
        const {steps, id} = hw
        return (
            <div key={`HomeworkTable-col-steps-${id}`}
                 className="HomeworkTable-col-steps">
                {steps.map(step => {
                    const {id, length, speed, finishedCount, count, isFinished} = step
                    const theme = getNameByValue(themes, step.theme);
                    const solveType = getNameByValue(solveTypes, step.solveType)
                    const taskType = getNameByValue(taskTypes, step.taskType)
                    const title = `Тема:\t\t${theme}\nСкорость: \t${speed} сек\nКоличество:     ${length}\nТип:\t\t   ${taskType}\n\t${solveType}`
                    return <div key={`HomeworkTable-col-step-${id}`}
                                className={`HomeworkTable-col-step ${isFinished && "HomeworkTable-col-step-finished"}`}
                                title={title}>
                        <span style={{fontSize: "0.7em"}}>{finishedCount}/{count}</span>
                    </div>
                })}
            </div>
        )
    }

    const renderHWColumn = (key) => {
        let header = <div key={`HomeworkTable-header-col-${key}`}
                          className="HomeworkTable-header HomeworkTable-col-date">
            <div>{moment(key, "YYYY-MM-DD").format("dddd")}</div>
            <div style={{fontSize: "0.8em"}}>{moment(key, "YYYY-MM-DD").format("DD.MM")}</div>
        </div>

        return <div key={`HomeworkTable-col-${key}`}
                    className="HomeworkTable-col">
            {
                [header, homeworks[key].sort((a, b) => {
                    const aName = `${a.student.lastName} ${a.student.firstName} ${a.student.middleName} ${a.student.id}`
                    const bName = `${b.student.lastName} ${b.student.firstName} ${b.student.middleName} ${b.id}`
                    return aName.localeCompare(bName)
                }).map(renderSteps)]
            }
        </div>
    }

    const renderEmptyLine = (s, i) => {
        return (
            <div key={`HomeworkTable-col-steps-empty-${i}`}
                 style={{padding: '1.3em 0'}}
                 className="HomeworkTable-col-steps">
                <div style={{height: '2.4em'}}></div>
            </div>
        )
    }

    return (
        <div className="HomeworkTable-wrapper">
            <div className="HomeworkTable-content">
                <div className="HomeworkTable-table">
                    <div className="HomeworkTable-col-names">
                        <div className="HomeworkTable-header HomeworkTable-header-name">Ученик</div>
                        {Object.values(students).sort((a, b) => {
                            const aName = `${a.lastName} ${a.firstName} ${a.middleName} ${a.id}`
                            const bName = `${b.lastName} ${b.firstName} ${b.middleName} ${b.id}`
                            return aName.localeCompare(bName)
                        }).map(renderName)}
                        {Object.values(other).map(renderName)}
                    </div>
                    <div className="HomeworkTable-col-hws">
                        <div style={{display: 'flex', width: '100%'}}>
                            {
                                Object.keys(homeworks).sort().map(renderHWColumn)
                            }
                            <div className="HomeworkTable-col-empty HomeworkTable-col">
                                <div className="HomeworkTable-col HomeworkTable-col-empty">
                                    <div style={{padding: 0}} className="HomeworkTable-header HomeworkTable-header-name"></div>
                                    {Array.from(Array(Object.values(students).length + Object.values(other).length)).map(renderEmptyLine)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

HomeworkTable.propTypes = {
    data: PropTypes.array,
}